<template>
  <div id="page-assessment">
    <el-form
      class="search-form"
      ref="searchForm"
      :inline="true"
      :model="searchForm"
      label-width="6em"
    >
      <el-row>
        <el-form-item prop="supplierId" label="合作商">
          <filter-businessline-partner
            :value.sync="supplierId"
            :code.sync="searchForm.supplierCode"
            :businessLine="2"
            required
          />
        </el-form-item>
        <el-form-item prop="regionId" label="Region">
          <filter-businessline-region :value.sync="searchForm.regionId" businessLine="2" />
        </el-form-item>
        <el-form-item label="时间段">
          <filter-date-range :value.sync="dateRange" />
        </el-form-item>
        <el-form-item style="float: right">
          <el-button type="primary" @click="fetchData" :loading="isLoading">查询</el-button>
          <el-button @click="exportDetail">导出明细</el-button>
        </el-form-item>
      </el-row>
    </el-form>
    <!-- 列表 -->
    <el-table stripe :data="dataList" v-loading="isLoading">
      <el-table-column
        v-for="item in __tableColumn"
        :key="item.prop"
        :prop="item.prop"
        :label="item.label"
        :min-width="item.minWidth || ''"
      >
        <template slot-scope="scoped">
          {{ item.filter ? item.filter(scoped.row) : scoped.row[item.prop] }}
        </template>
        <template v-if="item.children && item.children.length">
          <el-table-column
            v-for="subItem in item.children"
            :prop="subItem.prop"
            :label="subItem.label"
            :key="subItem.prop"
            :min-width="item.minWidth || ''"
          >
            <template slot-scope="scoped">
              {{ subItem.filter ? subItem.filter(scoped.row) : scoped.row[subItem.prop] }}
            </template>
          </el-table-column>
        </template>
      </el-table-column>
    </el-table>
    <div class="paging-wrapper" v-if="totalPages > 1">
      <el-pagination
        background
        @current-change="handlePageNoChange"
        :current-page.sync="pageNo"
        :page-size="pageSize"
        layout="prev, pager, next, slot, jumper"
        :total="totalAmount"
      >
        <span class="page-indicator"
          ><em>{{ pageNo }}</em
          >/{{ totalPages }}</span
        >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { dateFormat } from '@/utils'
import pagination from '@/mixins/pagination'
import qs from 'qs'
import { api } from '@/api/apiList'

export default {
  mixins: [pagination],

  data() {
    this.__tableColumn = [
      {
        label: 'Region',
        prop: 'regionId',
        filter: (row) => {
          return `${row.regionName}(${row.regionId})`
        },
      },
      {
        label: '考核工种',
        prop: 'workTypeDesc',
      },
      {
        label: '用工类型',
        prop: 'userTypeDesc',
      },
      {
        label: '合作商',
        prop: 'partnerList',
        filter: (row) => {
          if (row.partnerList && row.partnerList.length > 0) {
            return row.partnerList
              .map((el) => {
                return `${el.supplierName}(${el.supplierCode})`
              })
              .join('、')
          }
          return '--'
        },
        minWidth: 200,
      },
      {
        label: '考核方案',
        children: [
          {
            label: '考核周期',
            prop: 'timeCycle',
            filter: (row) => {
              if (row.performancePlan && row.performancePlan.timeCycle) {
                return row.performancePlan.timeCycle
              }
              return '--'
            },
          },
          {
            label: '考核标准',
            prop: 't2',
            filter: (row) => {
              if (row.performancePlan && row.performancePlan.normList) {
                return row.performancePlan.normList.map((el) => el.desc).join('、')
              }
              return '--'
            },
            minWidth: 130,
          },
          {
            label: '生效时间',
            prop: 'validDateBegin',
            filter: (row) => {
              return dateFormat(row.performancePlan.validDateBegin) || '--'
            },
          },
          {
            label: '结束时间',
            prop: 'validDateEnd',
            filter: (row) => {
              return dateFormat(row.performancePlan.validDateEnd) || '--'
            },
          },
        ],
      },
    ]
    return {
      isLoading: false,
      dataList: [],
      dateRange: [],
      pageSize: 20,
      totalAmount: 0,
      supplierId: '',
      searchForm: {
        regionId: '',
        supplierCode: '',
        validDateBegin: '',
        validDateEnd: '',
      },
    }
  },

  created() {
    this.initPagination('fetchData', false)
  },

  methods: {
    // 列表
    fetchData() {
      const params = {
        ...this.searchForm,
        validDateBegin: this.dateRange[0],
        validDateEnd: this.dateRange[1],
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }
      this.isLoading = true
      this.fetch
        .get('peformancePlans', { params })
        .then((res) => {
          const { list = [], totalCount = 0 } = res.data || {}
          this.dataList = list || []
          this.totalAmount = totalCount
        })
        .catch(() => {})
        .finally(() => {
          this.isLoading = false
        })
    },

    // 导出
    exportDetail() {
      const params = {
        ...this.searchForm,
        validDateBegin: this.dateRange[0],
        validDateEnd: this.dateRange[1],
        pageNo: 1,
        pageSize: 1000000,
      }
      window.open(`${api.exportPeformancePlans}?${qs.stringify(params)}`)
    },
  },
}
</script>
